<template>
  <div class="board">
    <!-- 牌池 4x13 -->
    <div class="pond">
      <div
        v-for="item in pondOrder"
        :key="'p'+item"
        :class="['cs', { taken: allSet.has(item) }]"
        @click="toFlip(item)"
      >
        <img v-if="allSet.has(item)" :src="backImg" draggable="false" />
        <img v-else :src="cardImgs[item]" draggable="false" />
      </div>
    </div>

    <!-- 下半区 -->
    <div :class="['players', isAllowed() ? 'layout-grid-img' : 'layout-grid']">
      <!-- 图片识别区 -->
      <div v-if="isAllowed()" :class="['recog-cell', { 'recog-drag-hover': recogDragHover }]"
        @click="triggerFilePick"
        @dragover.prevent="onRecogDragOver"
        @dragleave="onRecogDragLeave"
        @drop.prevent="onRecogDrop">
        <template v-if="recogImageUrl">
          <el-tooltip content="点击可重新选择图片，也可直接拖入新图片" placement="top" :open-delay="500">
            <img :src="recogImageUrl" class="recog-preview" />
          </el-tooltip>
          <div v-if="recognizing" class="recog-status">
            <div class="recog-spinner-sm"></div>
            <span>识别中...</span>
          </div>
        </template>
        <div v-else class="recog-placeholder">
          <span v-if="recognizing" class="recog-loading-inline"><span class="recog-spinner-sm"></span> 识别中...</span>
          <template v-else>
            <span style="font-size:14px;font-weight:bold;">点击选择图片 或 拖入图片</span>
            <span style="font-size:11px;color:#999;margin-top:6px;line-height:1.5;">点击/拖入手牌照片，自动识别并选牌<br/>有图片时点击可重新选择<br/>4家满牌时上传新图会自动重置全部</span>
          </template>
        </div>
        <div class="watch-overlay" @click.stop>
          <el-tooltip content="选择摄像头抓拍图片保存的文件夹" placement="bottom" :open-delay="400">
            <button class="watch-btn watch-btn-folder" @click.stop="pickWatchFolder">
              {{ watchDirHandle ? '换目录' : '选目录' }}
            </button>
          </el-tooltip>
          <el-tooltip :content="watchActive ? '点击停止自动监控' : (watchDirHandle ? '开启后自动识别新图片' : '请先选择文件夹')" placement="bottom" :open-delay="400">
            <button :class="['watch-btn', watchActive ? 'watch-btn-stop' : 'watch-btn-start']"
              :disabled="!watchDirHandle" @click.stop="toggleWatch">
              {{ watchActive ? '停止' : '自动抓图' }}
            </button>
          </el-tooltip>
          <span v-if="watchDirName && watchActive" class="watch-status-dot" :title="watchDirName"></span>
        </div>
        <input ref="recogInput" type="file" accept="image/*" @change="onRecogFile($event)" style="display:none" />
      </div>
      <!-- P4 剩余牌 -->
      <div class="quad remaining-bg">
        <div class="quad-head">
          <el-tooltip content="3位玩家各选满13张后，自动显示第4位玩家的13张牌" placement="top" :open-delay="400">
            <span class="p4-badge">剩余牌</span>
          </el-tooltip>
          <el-tooltip v-if="specialP4" content="特殊牌型，直接获胜" placement="top" :open-delay="300">
            <span class="special-badge">{{ specialP4.name }}</span>
          </el-tooltip>
          <div class="head-btns">
            <el-tooltip v-if="list5.length === 13" :content="optMode.p4 === 'opt' ? '当前为最优摆法，点击切换回顺序' : '按花色和点数从小到大排列，点击切换最优摆法'" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.p4 === 'opt' ? 'opt-active' : 'opt-inactive']" @click="toggleOpt('p4')">{{ optMode.p4 === 'opt' ? '★ 最优' : '☰ 顺序' }}</button>
            </el-tooltip>
            <el-tooltip content="清空所有玩家的牌，重新开始一局" placement="top" :open-delay="400">
              <button class="btn-reset-all" @click="confirmResetAll()">⚠ 重置全部</button>
            </el-tooltip>
          </div>
          <div v-if="optMode.p4 === 'opt' && topListP4.length" class="rank-bar">
            <el-tooltip v-for="(r, ri) in topListP4" :key="'rp4'+ri" :content="'第' + (ri+1) + '种最优摆法，胜率' + r.score + '%'" placement="top" :open-delay="400">
              <button :class="['rank-btn', { 'rank-active': optRank.p4 === ri }]" @click="setOptRank('p4', ri)">
                <span class="rank-no">{{ ri + 1 }}</span><span class="rank-pct">{{ r.score }}%</span>
              </button>
            </el-tooltip>
          </div>
        </div>
        <div class="hand-area" v-if="all.length >= 39">
          <div class="hand-row">
            <div v-for="item in splitHand(displayListP4).front" :key="'r0f'+item"
              class="hc pc-p4" @click="toTop(item)">
              <img :src="cardImgs[item]" draggable="false" />
            </div>
          </div>
          <div class="hand-row">
            <div v-for="item in splitHand(displayListP4).mid" :key="'r0m'+item"
              class="hc pc-p4" @click="toTop(item)">
              <img :src="cardImgs[item]" draggable="false" />
            </div>
          </div>
          <div class="hand-row hand-back">
            <div v-for="item in splitHand(displayListP4).back" :key="'r0b'+item"
              class="hc pc-p4" @click="toTop(item)">
              <img :src="cardImgs[item]" draggable="false" />
            </div>
          </div>
        </div>
        <div class="hand-area hand-empty" v-else>
          <span class="empty-hint">等待3位玩家<br>各选满13张</span>
        </div>
      </div>

      <!-- P1 -->
      <div class="quad bg-p1" :style="playerAreas.selectList1 ? {gridArea: playerAreas.selectList1} : {}">
        <div class="quad-head">
          <el-tooltip :content="'玩家1，已选' + selectList1.length + '张牌'" placement="top" :open-delay="400">
            <span class="tag tg-1">P1 · {{ selectList1.length }}</span>
          </el-tooltip>
          <el-tooltip v-if="special1" content="特殊牌型，直接获胜" placement="top" :open-delay="300">
            <span class="special-badge">{{ special1.name }}</span>
          </el-tooltip>
          <div class="head-btns">
            <el-tooltip v-if="selectList1.length === 13" :content="optMode.selectList1 === 'opt' ? '当前为最优摆法，点击切换回顺序' : '按花色和点数从小到大排列，点击切换最优摆法'" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.selectList1 === 'opt' ? 'opt-active' : 'opt-inactive']" @click="toggleOpt('selectList1')">{{ optMode.selectList1 === 'opt' ? '★ 最优' : '☰ 顺序' }}</button>
            </el-tooltip>
            <el-tooltip v-if="userKey === 'selectList1' && recogOrder.length > 0" content="按图片识别的从左到右顺序排列" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.selectList1 === 'recog' ? 'opt-recog-active' : 'opt-inactive']" @click="setRecogMode('selectList1')">📷 图序</button>
            </el-tooltip>
            <el-tooltip v-if="userKey === 'selectList1'" content="清空当前玩家的牌，退回牌池" placement="top" :open-delay="400">
              <button class="btn" @click="clearPlayingCardOne()">重置</button>
            </el-tooltip>
          </div>
          <div v-if="optMode.selectList1 === 'opt' && topList1.length" class="rank-bar">
            <el-tooltip v-for="(r, ri) in topList1" :key="'r1'+ri" :content="'第' + (ri+1) + '种最优摆法，胜率' + r.score + '%'" placement="top" :open-delay="400">
              <button :class="['rank-btn', { 'rank-active': optRank.selectList1 === ri }]" @click="setOptRank('selectList1', ri)">
                <span class="rank-no">{{ ri + 1 }}</span><span class="rank-pct">{{ r.score }}%</span>
              </button>
            </el-tooltip>
          </div>
        </div>
        <div class="hand-area">
          <div class="hand-row">
            <div v-for="(item, i) in splitHand(displayList1).front" :key="'h1f'+item"
              :class="['hc', 'b-yellow', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList1' && !optMode.selectList1"
              @click="returnCard(item, 'selectList1')"
              @dragstart="onDragStart($event, i, 'selectList1')"
              @dragover.prevent @drop="onDrop($event, i, 'selectList1')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
          <div class="hand-row">
            <div v-for="(item, i) in splitHand(displayList1).mid" :key="'h1m'+item"
              :class="['hc', 'b-yellow', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList1' && !optMode.selectList1"
              @click="returnCard(item, 'selectList1')"
              @dragstart="onDragStart($event, i+3, 'selectList1')"
              @dragover.prevent @drop="onDrop($event, i+3, 'selectList1')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
          <div class="hand-row hand-back">
            <div v-for="(item, i) in splitHand(displayList1).back" :key="'h1b'+item"
              :class="['hc', 'b-yellow', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList1' && !optMode.selectList1"
              @click="returnCard(item, 'selectList1')"
              @dragstart="onDragStart($event, i+8, 'selectList1')"
              @dragover.prevent @drop="onDrop($event, i+8, 'selectList1')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
        </div>
      </div>

      <!-- P2 -->
      <div class="quad bg-p2" :style="playerAreas.selectList2 ? {gridArea: playerAreas.selectList2} : {}">
        <div class="quad-head">
          <el-tooltip :content="'玩家2，已选' + selectList2.length + '张牌'" placement="top" :open-delay="400">
            <span class="tag tg-2">P2 · {{ selectList2.length }}</span>
          </el-tooltip>
          <el-tooltip v-if="special2" content="特殊牌型，直接获胜" placement="top" :open-delay="300">
            <span class="special-badge">{{ special2.name }}</span>
          </el-tooltip>
          <div class="head-btns">
            <el-tooltip v-if="selectList2.length === 13" :content="optMode.selectList2 === 'opt' ? '当前为最优摆法，点击切换回顺序' : '按花色和点数从小到大排列，点击切换最优摆法'" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.selectList2 === 'opt' ? 'opt-active' : 'opt-inactive']" @click="toggleOpt('selectList2')">{{ optMode.selectList2 === 'opt' ? '★ 最优' : '☰ 顺序' }}</button>
            </el-tooltip>
            <el-tooltip v-if="userKey === 'selectList2' && recogOrder.length > 0" content="按图片识别的从左到右顺序排列" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.selectList2 === 'recog' ? 'opt-recog-active' : 'opt-inactive']" @click="setRecogMode('selectList2')">📷 图序</button>
            </el-tooltip>
            <el-tooltip v-if="userKey === 'selectList2'" content="清空当前玩家的牌，退回牌池" placement="top" :open-delay="400">
              <button class="btn" @click="clearPlayingCardOne()">重置</button>
            </el-tooltip>
          </div>
          <div v-if="optMode.selectList2 === 'opt' && topList2.length" class="rank-bar">
            <el-tooltip v-for="(r, ri) in topList2" :key="'r2'+ri" :content="'第' + (ri+1) + '种最优摆法，胜率' + r.score + '%'" placement="top" :open-delay="400">
              <button :class="['rank-btn', { 'rank-active': optRank.selectList2 === ri }]" @click="setOptRank('selectList2', ri)">
                <span class="rank-no">{{ ri + 1 }}</span><span class="rank-pct">{{ r.score }}%</span>
              </button>
            </el-tooltip>
          </div>
        </div>
        <div class="hand-area">
          <div class="hand-row">
            <div v-for="(item, i) in splitHand(displayList2).front" :key="'h2f'+item"
              :class="['hc', 'b-red', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList2' && !optMode.selectList2"
              @click="returnCard(item, 'selectList2')"
              @dragstart="onDragStart($event, i, 'selectList2')"
              @dragover.prevent @drop="onDrop($event, i, 'selectList2')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
          <div class="hand-row">
            <div v-for="(item, i) in splitHand(displayList2).mid" :key="'h2m'+item"
              :class="['hc', 'b-red', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList2' && !optMode.selectList2"
              @click="returnCard(item, 'selectList2')"
              @dragstart="onDragStart($event, i+3, 'selectList2')"
              @dragover.prevent @drop="onDrop($event, i+3, 'selectList2')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
          <div class="hand-row hand-back">
            <div v-for="(item, i) in splitHand(displayList2).back" :key="'h2b'+item"
              :class="['hc', 'b-red', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList2' && !optMode.selectList2"
              @click="returnCard(item, 'selectList2')"
              @dragstart="onDragStart($event, i+8, 'selectList2')"
              @dragover.prevent @drop="onDrop($event, i+8, 'selectList2')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
        </div>
      </div>

      <!-- P3 -->
      <div class="quad bg-p3" :style="playerAreas.selectList3 ? {gridArea: playerAreas.selectList3} : {}">
        <div class="quad-head">
          <el-tooltip :content="'玩家3，已选' + selectList3.length + '张牌'" placement="top" :open-delay="400">
            <span class="tag tg-3">P3 · {{ selectList3.length }}</span>
          </el-tooltip>
          <el-tooltip v-if="special3" content="特殊牌型，直接获胜" placement="top" :open-delay="300">
            <span class="special-badge">{{ special3.name }}</span>
          </el-tooltip>
          <div class="head-btns">
            <el-tooltip v-if="selectList3.length === 13" :content="optMode.selectList3 === 'opt' ? '当前为最优摆法，点击切换回顺序' : '按花色和点数从小到大排列，点击切换最优摆法'" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.selectList3 === 'opt' ? 'opt-active' : 'opt-inactive']" @click="toggleOpt('selectList3')">{{ optMode.selectList3 === 'opt' ? '★ 最优' : '☰ 顺序' }}</button>
            </el-tooltip>
            <el-tooltip v-if="userKey === 'selectList3' && recogOrder.length > 0" content="按图片识别的从左到右顺序排列" placement="top" :open-delay="400">
              <button :class="['btn-opt', optMode.selectList3 === 'recog' ? 'opt-recog-active' : 'opt-inactive']" @click="setRecogMode('selectList3')">📷 图序</button>
            </el-tooltip>
            <el-tooltip v-if="userKey === 'selectList3'" content="清空当前玩家的牌，退回牌池" placement="top" :open-delay="400">
              <button class="btn" @click="clearPlayingCardOne()">重置</button>
            </el-tooltip>
          </div>
          <div v-if="optMode.selectList3 === 'opt' && topList3.length" class="rank-bar">
            <el-tooltip v-for="(r, ri) in topList3" :key="'r3'+ri" :content="'第' + (ri+1) + '种最优摆法，胜率' + r.score + '%'" placement="top" :open-delay="400">
              <button :class="['rank-btn', { 'rank-active': optRank.selectList3 === ri }]" @click="setOptRank('selectList3', ri)">
                <span class="rank-no">{{ ri + 1 }}</span><span class="rank-pct">{{ r.score }}%</span>
              </button>
            </el-tooltip>
          </div>
        </div>
        <div class="hand-area">
          <div class="hand-row">
            <div v-for="(item, i) in splitHand(displayList3).front" :key="'h3f'+item"
              :class="['hc', 'b-green', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList3' && !optMode.selectList3"
              @click="returnCard(item, 'selectList3')"
              @dragstart="onDragStart($event, i, 'selectList3')"
              @dragover.prevent @drop="onDrop($event, i, 'selectList3')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
          <div class="hand-row">
            <div v-for="(item, i) in splitHand(displayList3).mid" :key="'h3m'+item"
              :class="['hc', 'b-green', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList3' && !optMode.selectList3"
              @click="returnCard(item, 'selectList3')"
              @dragstart="onDragStart($event, i+3, 'selectList3')"
              @dragover.prevent @drop="onDrop($event, i+3, 'selectList3')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
          <div class="hand-row hand-back">
            <div v-for="(item, i) in splitHand(displayList3).back" :key="'h3b'+item"
              :class="['hc', 'b-green', { dragging: dragItem === item }]"
              :draggable="userKey === 'selectList3' && !optMode.selectList3"
              @click="returnCard(item, 'selectList3')"
              @dragstart="onDragStart($event, i+8, 'selectList3')"
              @dragover.prevent @drop="onDrop($event, i+8, 'selectList3')" @dragend="onDragEnd"
            ><img :src="cardImgs[item]" draggable="false" /></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const cardImgs = {};
for (let i = 1; i <= 52; i++) {
  cardImgs[i] = require(`@/assets/${i}.webp`);
}
const backImg = require("@/assets/1_2.webp");
const placeholderImg = require("@/assets/57.png");

function suitOrder(base) {
  return [1,2,3,4,5,6,7,8,9,11,12,13,10].map(i => base + i);
}
const pondOrder = [
  ...suitOrder(0),
  ...suitOrder(13),
  ...suitOrder(26),
  ...suitOrder(39),
];

function cardRank(c) {
  const suit = Math.floor((c - 1) / 13);
  const pos = ((c - 1) % 13) + 1;
  let rank;
  if (pos <= 9) rank = pos;
  else if (pos === 11) rank = 10;
  else if (pos === 12) rank = 11;
  else if (pos === 13) rank = 12;
  else rank = 13;
  return rank * 4 + suit;
}
function sortCards(arr) {
  return [...arr].sort((a, b) => cardRank(a) - cardRank(b));
}

/* ===== 识别程序 class_id → 记牌系统 card_id 映射 ===== */
var RECOG_SUIT_MAP = [0, 1, 3, 2]; // 识别: s=0,h=1,d=2,c=3 → 系统: s=0,h=1,c=2,d=3
function classIdToCardId(classId) {
  var recSuit = Math.floor(classId / 13);
  var recRank = classId % 13; // 0=A,1=2,...,9=10,10=J,11=Q,12=K
  var pokerSuit = RECOG_SUIT_MAP[recSuit];
  var base = pokerSuit * 13;
  var pos;
  if (recRank === 0) pos = 10;
  else if (recRank <= 9) pos = recRank;
  else pos = recRank + 1;
  return base + pos;
}
var SUIT_SYMBOLS = ['♠', '♥', '♣', '♦'];
function cardIdToName(cardId) {
  var suit = Math.floor((cardId - 1) / 13);
  var pos = ((cardId - 1) % 13) + 1;
  var rn;
  if (pos <= 9) rn = '' + (pos + 1);
  else if (pos === 10) rn = 'A';
  else if (pos === 11) rn = 'J';
  else if (pos === 12) rn = 'Q';
  else rn = 'K';
  return SUIT_SYMBOLS[suit] + rn;
}

/* ===== 十三水最优排列算法 ===== */
function getCardInfo(c) {
  const suit = Math.floor((c - 1) / 13);
  const pos = ((c - 1) % 13) + 1;
  let rank;
  if (pos <= 9) rank = pos + 1;
  else if (pos === 10) rank = 14;
  else if (pos === 11) rank = 11;
  else if (pos === 12) rank = 12;
  else rank = 13;
  return { rank, suit };
}

function evalHand5(cards) {
  const infos = cards.map(getCardInfo);
  const ranks = infos.map(i => i.rank).sort((a, b) => b - a);
  const suits = infos.map(i => i.suit);
  const isFlush = suits.every(s => s === suits[0]);

  const uniq = [...new Set(ranks)].sort((a, b) => b - a);
  let isStraight = false, straightHi = 0;
  if (uniq.length === 5) {
    if (uniq[0] - uniq[4] === 4) { isStraight = true; straightHi = uniq[0]; }
    if (uniq[0] === 14 && uniq[1] === 5 && uniq[4] === 2) { isStraight = true; straightHi = 5; }
  }

  const cnt = {};
  ranks.forEach(r => cnt[r] = (cnt[r] || 0) + 1);
  const grp = Object.entries(cnt).map(([r, c]) => [c, +r]).sort((a, b) => b[0] - a[0] || b[1] - a[1]);

  let cat, k;
  if (isFlush && isStraight) { cat = 8; k = [straightHi, 0, 0, 0, 0]; }
  else if (grp[0][0] === 4) { cat = 7; k = [grp[0][1], grp[1][1], 0, 0, 0]; }
  else if (grp[0][0] === 3 && grp[1][0] === 2) { cat = 6; k = [grp[0][1], grp[1][1], 0, 0, 0]; }
  else if (isFlush) { cat = 5; k = [ranks[0], ranks[1], ranks[2], ranks[3], ranks[4]]; }
  else if (isStraight) { cat = 4; k = [straightHi, 0, 0, 0, 0]; }
  else if (grp[0][0] === 3) { cat = 3; k = [grp[0][1], grp[1][1], grp[2][1], 0, 0]; }
  else if (grp[0][0] === 2 && grp[1][0] === 2) {
    const p1 = Math.max(grp[0][1], grp[1][1]), p2 = Math.min(grp[0][1], grp[1][1]);
    cat = 2; k = [p1, p2, grp[2][1], 0, 0];
  }
  else if (grp[0][0] === 2) {
    const rest = grp.slice(1).map(g => g[1]).sort((a, b) => b - a);
    cat = 1; k = [grp[0][1], rest[0], rest[1], rest[2], 0];
  }
  else { cat = 0; k = [ranks[0], ranks[1], ranks[2], ranks[3], ranks[4]]; }

  return cat * 1e10 + k[0] * 50625 + k[1] * 3375 + k[2] * 225 + k[3] * 15 + k[4];
}

function evalHand3(cards) {
  const infos = cards.map(getCardInfo);
  const ranks = infos.map(i => i.rank).sort((a, b) => b - a);
  const cnt = {};
  ranks.forEach(r => cnt[r] = (cnt[r] || 0) + 1);
  const grp = Object.entries(cnt).map(([r, c]) => [c, +r]).sort((a, b) => b[0] - a[0] || b[1] - a[1]);

  let cat, k;
  if (grp[0][0] === 3) { cat = 3; k = [grp[0][1], 0, 0]; }
  else if (grp[0][0] === 2) { cat = 1; k = [grp[0][1], grp[1][1], 0]; }
  else { cat = 0; k = [ranks[0], ranks[1], ranks[2]]; }

  return cat * 1e6 + k[0] * 225 + k[1] * 15 + k[2];
}

/*
 * Position-specific win probability estimates (×1000).
 * Based on "Near-optimal closed-hand Chinese Poker" by Paul Hankin.
 * Each function maps a hand score to the approximate % chance of
 * winning that position against a random opponent (4-2 scoring).
 */
function frontPct(fS) {
  var cat = Math.floor(fS / 1e6);
  var kick = fS % 1e6;
  if (cat >= 3) return 995;
  if (cat === 1) {
    var pr = Math.floor(kick / 225);
    var kr = Math.floor((kick % 225) / 15);
    var tbl = [0,0,470,480,490,505,525,570,600,635,675,725,780,845,920];
    var b = tbl[pr] || 470;
    var n = pr < 14 ? (tbl[pr + 1] || 995) : 995;
    return Math.min(b + Math.round((kr - 2) / 12 * (n - b)), 995);
  }
  var r1 = Math.floor(kick / 225);
  var sub = kick % 225;
  var maxSub = (r1 - 1) * 15 + (r1 - 2);
  var bases = [0,0,0,0, 1, 4, 7, 11, 16, 22, 27, 50, 80, 107, 210];
  var tops  = [0,0,0,0, 1, 6, 10, 15, 21, 26, 49, 79, 106, 208, 467];
  var lo = bases[r1] || 1, hi = tops[r1] || lo;
  if (hi <= lo || maxSub <= 47) return lo;
  return lo + Math.round((hi - lo) * Math.max(sub - 47, 0) / (maxSub - 47));
}

function midPct(mS) {
  var cat = Math.floor(mS / 1e10);
  var kick = mS % 1e10;
  var pr = Math.floor(kick / 50625);
  if (cat >= 7) return 1000;
  if (cat === 6) return 994 + Math.round(Math.max(pr - 2, 0) / 12 * 6);
  if (cat === 5) return 911 + Math.round(kick / 756000 * 82);
  if (cat === 4) return 755 + Math.round(Math.max(pr - 5, 0) / 9 * 155);
  if (cat === 3) return 644 + Math.round(Math.max(pr - 2, 0) / 12 * 89);
  if (cat === 2) {
    var pr2 = Math.floor((kick % 50625) / 3375);
    return Math.min(362 + Math.round(Math.max(pr - 3, 0) / 11 * 200 + Math.max(pr2 - 2, 0) / 12 * 80), 632);
  }
  if (cat === 1) return 13 + Math.round(Math.max(pr - 2, 0) / 12 * 347);
  return Math.round(kick / 756000 * 13);
}

function backPct(bS) {
  var cat = Math.floor(bS / 1e10);
  var kick = bS % 1e10;
  var pr = Math.floor(kick / 50625);
  if (cat >= 8) return 991 + Math.round(Math.max(pr - 5, 0) / 9 * 9);
  if (cat === 7) return 966 + Math.round(Math.max(pr - 2, 0) / 12 * 24);
  if (cat === 6) {
    var pr2 = Math.floor((kick % 50625) / 3375);
    return Math.min(673 + Math.round(Math.max(pr - 2, 0) / 12 * 275 + Math.max(pr2 - 2, 0) / 12 * 17), 965);
  }
  if (cat === 5) return 361 + Math.round(kick / 756000 * 293);
  if (cat === 4) return 170 + Math.round(Math.max(pr - 5, 0) / 9 * 191);
  if (cat === 3) return 144 + Math.round(Math.max(pr - 2, 0) / 12 * 10);
  if (cat === 2) return 18 + Math.round(Math.max(pr - 3, 0) / 11 * 126);
  if (cat === 1) return Math.round(Math.max(pr - 2, 0) / 12 * 17);
  return 0;
}

const optCache = new Map();
function findTopOptimal(cardIds) {
  if (cardIds.length < 13) return [{ arr: cardIds, score: 0, pf: 0, pm: 0, pb: 0 }];
  const cards = cardIds.slice(0, 13);
  const cacheKey = [...cards].sort((a, b) => a - b).join(",");
  if (optCache.has(cacheKey)) return optCache.get(cacheKey);

  var top5 = [];
  var minTop = -1;

  for (let i = 0; i < 11; i++) {
    for (let j = i + 1; j < 12; j++) {
      for (let k = j + 1; k < 13; k++) {
        const front = [cards[i], cards[j], cards[k]];
        const fS = evalHand3(front);
        const rest = [];
        for (let x = 0; x < 13; x++) if (x !== i && x !== j && x !== k) rest.push(cards[x]);

        for (let a = 0; a < 6; a++) {
          for (let b = a + 1; b < 7; b++) {
            for (let c = b + 1; c < 8; c++) {
              for (let d = c + 1; d < 9; d++) {
                for (let e = d + 1; e < 10; e++) {
                  const gA = [rest[a], rest[b], rest[c], rest[d], rest[e]];
                  const gB = [];
                  for (let x = 0; x < 10; x++) if (x !== a && x !== b && x !== c && x !== d && x !== e) gB.push(rest[x]);

                  let sA = evalHand5(gA), sB = evalHand5(gB);
                  let mid, back, mS, bS;
                  if (sA >= sB) { back = gA; bS = sA; mid = gB; mS = sB; }
                  else { back = gB; bS = sB; mid = gA; mS = sA; }

                  // 倒水检查：前墩不能大于中墩（类别+同类别内大小都要比）
                  const fCat = Math.floor(fS / 1e6);
                  const mCat = Math.floor(mS / 1e10);
                  if (fCat > mCat) continue;
                  if (fCat === mCat) {
                    const fPri = Math.floor((fS % 1e6) / 225);
                    const mPri = Math.floor((mS % 1e10) / 50625);
                    if (fPri > mPri) continue;
                    if (fPri === mPri) {
                      const fSec = Math.floor((fS % 1e6) % 225 / 15);
                      const mSec = Math.floor((mS % 1e10) % 50625 / 3375);
                      if (fSec > mSec) continue;
                    }
                  }

                  var pf = frontPct(fS) / 1000;
                  var pm = midPct(mS) / 1000;
                  var pb = backPct(bS) / 1000;
                  var total = pf + pm + pb + pf * pm + pf * pb + pm * pb - 2 * pf * pm * pb;

                  if (top5.length < 5 || total > minTop) {
                    var arrKey = [...front, ...mid, ...back].join(",");
                    var dup = false;
                    for (var ti = 0; ti < top5.length; ti++) {
                      if (top5[ti].key === arrKey) { dup = true; break; }
                    }
                    if (!dup) {
                      top5.push({ arr: [...front, ...mid, ...back], score: total, pf: pf, pm: pm, pb: pb, key: arrKey });
                      top5.sort(function(x, y) { return y.score - x.score; });
                      if (top5.length > 5) top5.length = 5;
                      minTop = top5[top5.length - 1].score;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  if (top5.length === 0) top5.push({ arr: cards, score: 0, pf: 0, pm: 0, pb: 0, key: "" });
  var results = top5.map(function(t) { return { arr: t.arr, score: Math.round(t.score / 4 * 1000) / 10, pf: Math.round(t.pf * 1000) / 10, pm: Math.round(t.pm * 1000) / 10, pb: Math.round(t.pb * 1000) / 10 }; });
  if (detectSpecialHand(cards)) {
    results = results.map(function(r) { return { arr: r.arr, score: 100, pf: 100, pm: 100, pb: 100 }; });
  }
  optCache.set(cacheKey, results);
  return results;
}

/* ===== 特殊牌型检测（9种标准特殊牌型，按稀有度从高到低） ===== */
function detectSpecialHand(cardIds) {
  if (cardIds.length !== 13) return null;
  var infos = cardIds.map(getCardInfo);
  var ranks = infos.map(function(i) { return i.rank; });
  var suits = infos.map(function(i) { return i.suit; });

  var rankFreq = {};
  ranks.forEach(function(r) { rankFreq[r] = (rankFreq[r] || 0) + 1; });
  var suitCounts = [0, 0, 0, 0];
  suits.forEach(function(s) { suitCounts[s]++; });

  // 1. 一条龙：13张各不同点数（2-A各一张）
  if (Object.keys(rankFreq).length === 13) return { name: '一条龙' };

  // 2. 三同花顺：三道均为同花顺
  if (isThreeStraightFlush(infos)) return { name: '三同花顺' };

  // 3. 三分天下：3组四条 + 1张
  var quadsCount = 0;
  Object.values(rankFreq).forEach(function(c) { if (c >= 4) quadsCount++; });
  if (quadsCount >= 3) return { name: '三分天下' };

  // 4. 四套三条：4组三条 + 1张
  var tripsCount = 0;
  Object.values(rankFreq).forEach(function(c) { if (c >= 3) tripsCount++; });
  if (tripsCount >= 4) return { name: '四套三条' };

  // 5. 全大：13张全 >= 8
  if (ranks.every(function(r) { return r >= 8; })) return { name: '全大' };

  // 6. 全小：13张全 <= 8
  if (ranks.every(function(r) { return r <= 8; })) return { name: '全小' };

  // 7. 六对半：6对 + 1张
  var pairCount = 0;
  Object.values(rankFreq).forEach(function(c) { pairCount += Math.floor(c / 2); });
  if (pairCount >= 6) return { name: '六对半' };

  // 8. 三顺子：三道均为顺子
  if (isThreeStraight(rankFreq)) return { name: '三顺子' };

  // 9. 三同花：三道均为同花
  if (isThreeFlush(suitCounts)) return { name: '三同花' };

  return null;
}

// 三同花顺检测：能否拆成 1个3张同花顺 + 2个5张同花顺
function isThreeStraightFlush(infos) {
  var has = new Set();
  infos.forEach(function(info) { has.add(info.rank * 10 + info.suit); });

  var sf3 = [[14, 2, 3]];
  for (var s = 2; s <= 12; s++) sf3.push([s, s + 1, s + 2]);
  var sf5 = [[14, 2, 3, 4, 5]];
  for (var s2 = 2; s2 <= 10; s2++) sf5.push([s2, s2 + 1, s2 + 2, s2 + 3, s2 + 4]);

  for (var s3 = 0; s3 < 4; s3++) {
    for (var a = 0; a < sf3.length; a++) {
      var r3 = sf3[a];
      if (!r3.every(function(r) { return has.has(r * 10 + s3); })) continue;
      r3.forEach(function(r) { has.delete(r * 10 + s3); });
      for (var sa = 0; sa < 4; sa++) {
        for (var b = 0; b < sf5.length; b++) {
          var ra = sf5[b];
          if (!ra.every(function(r) { return has.has(r * 10 + sa); })) continue;
          ra.forEach(function(r) { has.delete(r * 10 + sa); });
          for (var sb = 0; sb < 4; sb++) {
            for (var c = 0; c < sf5.length; c++) {
              var rb = sf5[c];
              if (rb.every(function(r) { return has.has(r * 10 + sb); })) {
                ra.forEach(function(r) { has.add(r * 10 + sa); });
                r3.forEach(function(r) { has.add(r * 10 + s3); });
                return true;
              }
            }
          }
          ra.forEach(function(r) { has.add(r * 10 + sa); });
        }
      }
      r3.forEach(function(r) { has.add(r * 10 + s3); });
    }
  }
  return false;
}

// 三同花检测：能否将4个花色的牌分成 3+5+5 且每组同花色
function isThreeFlush(sc) {
  for (var f = 0; f < 4; f++)
    for (var m = 0; m < 4; m++)
      for (var b = 0; b < 4; b++) {
        var need = [0, 0, 0, 0];
        need[f] += 3; need[m] += 5; need[b] += 5;
        if (need[0] <= sc[0] && need[1] <= sc[1] && need[2] <= sc[2] && need[3] <= sc[3]) return true;
      }
  return false;
}

// 三顺子检测：能否拆成 1个3连 + 2个5连
function isThreeStraight(rankFreq) {
  var rc = new Array(15).fill(0);
  for (var r = 2; r <= 14; r++) rc[r] = rankFreq[r] || 0;

  var s3 = [[14, 2, 3]];
  for (var i = 2; i <= 12; i++) s3.push([i, i + 1, i + 2]);

  var s5 = [[14, 2, 3, 4, 5]];
  for (var j = 2; j <= 10; j++) s5.push([j, j + 1, j + 2, j + 3, j + 4]);

  for (var a = 0; a < s3.length; a++) {
    var r3 = s3[a];
    for (var b = 0; b < s5.length; b++) {
      for (var c = b; c < s5.length; c++) {
        var need = new Array(15).fill(0);
        r3.forEach(function(r) { need[r]++; });
        s5[b].forEach(function(r) { need[r]++; });
        s5[c].forEach(function(r) { need[r]++; });
        var ok = true;
        for (var r = 2; r <= 14; r++) {
          if (need[r] > rc[r]) { ok = false; break; }
        }
        if (ok) return true;
      }
    }
  }
  return false;
}

export default {
  name: "CardBoard",
  data() {
    return {
      pondOrder,
      cardImgs,
      backImg,
      placeholderImg,

      selectList1: [],
      selectList2: [],
      selectList3: [],
      list5: [],
      all: [],
      list5Up: [],
      click3: [],
      click4: [],
      click5: [],

      userKey: "",
      timer: null,
      fetching: false,
      actionTs: 0,
      dragItem: null,
      dragFromIdx: -1,
      dragListKey: "",
      hasCustomOrder: false,
      lastNotifyTs: 0,
      optMode: { selectList1: '', selectList2: '', selectList3: '', p4: '' },
      optRank: { selectList1: 0, selectList2: 0, selectList3: 0, p4: 0 },
      roundStartTs: 0,
      roundStartLocal: 0,
      recognizing: false,
      recogImageUrl: null,
      recogDragHover: false,
      recogOrder: [],
      watchDirHandle: null,
      watchActive: false,
      watchTimer: null,
      watchKnownFiles: new Set(),
      watchDirName: '',
      watchSupported: typeof window.showDirectoryPicker === 'function',
    };
  },
  computed: {
    allSet() { return new Set(this.all); },
    weSet() { return new Set(this.list5Up); },
    click3Set() { return new Set(this.click3); },
    click4Set() { return new Set(this.click4); },
    click5Set() { return new Set(this.click5); },
    topList1() { return this.selectList1.length === 13 ? findTopOptimal(this.selectList1) : []; },
    topList2() { return this.selectList2.length === 13 ? findTopOptimal(this.selectList2) : []; },
    topList3() { return this.selectList3.length === 13 ? findTopOptimal(this.selectList3) : []; },
    topListP4() { return this.list5.length === 13 ? findTopOptimal(this.list5) : []; },
    special1() { return this.selectList1.length === 13 ? detectSpecialHand(this.selectList1) : null; },
    special2() { return this.selectList2.length === 13 ? detectSpecialHand(this.selectList2) : null; },
    special3() { return this.selectList3.length === 13 ? detectSpecialHand(this.selectList3) : null; },
    specialP4() { return this.list5.length === 13 ? detectSpecialHand(this.list5) : null; },
    displayList1() {
      if (this.optMode.selectList1 === 'opt' && this.topList1.length) return this.topList1[this.optRank.selectList1].arr;
      if (this.optMode.selectList1 === 'recog' && this.userKey === 'selectList1' && this.recogOrder.length > 0) {
        var s = new Set(this.selectList1), os = new Set(this.recogOrder);
        return this.recogOrder.filter(function(c) { return s.has(c); }).concat(sortCards(this.selectList1.filter(function(c) { return !os.has(c); })));
      }
      return this.selectList1;
    },
    displayList2() {
      if (this.optMode.selectList2 === 'opt' && this.topList2.length) return this.topList2[this.optRank.selectList2].arr;
      if (this.optMode.selectList2 === 'recog' && this.userKey === 'selectList2' && this.recogOrder.length > 0) {
        var s = new Set(this.selectList2), os = new Set(this.recogOrder);
        return this.recogOrder.filter(function(c) { return s.has(c); }).concat(sortCards(this.selectList2.filter(function(c) { return !os.has(c); })));
      }
      return this.selectList2;
    },
    displayList3() {
      if (this.optMode.selectList3 === 'opt' && this.topList3.length) return this.topList3[this.optRank.selectList3].arr;
      if (this.optMode.selectList3 === 'recog' && this.userKey === 'selectList3' && this.recogOrder.length > 0) {
        var s = new Set(this.selectList3), os = new Set(this.recogOrder);
        return this.recogOrder.filter(function(c) { return s.has(c); }).concat(sortCards(this.selectList3.filter(function(c) { return !os.has(c); })));
      }
      return this.selectList3;
    },
    displayListP4() {
      if (this.optMode.p4 === 'opt' && this.topListP4.length) return this.topListP4[this.optRank.p4].arr;
      return this.list5;
    },
    playerAreas: function() {
      if (!this.isAllowed()) return {};
      var a = {};
      var keys = ['selectList1', 'selectList2', 'selectList3'];
      var oidx = 1;
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === this.userKey) a[keys[i]] = 'self';
        else { a[keys[i]] = 'other' + oidx; oidx++; }
      }
      return a;
    },
  },
  created() {
    if (!this.userInfo || !this.userInfo.id) {
      this.$router.push("/");
      return;
    }
    const roleMap = { 2: "mainWork", 3: "selectList1", 4: "selectList2", 5: "selectList3" };
    this.userKey = roleMap[this.userInfo.id] || "look";

    this.fetchData();
    this.timer = setInterval(() => this.fetchData(), 1500);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    splitHand(list) {
      return {
        front: list.slice(0, Math.min(3, list.length)),
        mid: list.slice(3, Math.min(8, list.length)),
        back: list.slice(8),
      };
    },

    fetchData() {
      if (this.fetching) return;
      if (Date.now() - this.actionTs < 1200) return;
      this.fetching = true;
      this.$api.getUser.getData().then((res) => {
        if (res.code == 1) {
          const d = res.data;
          const listMap = { selectList1: d[3] || [], selectList2: d[4] || [], selectList3: d[5] || [] };
          for (const key of ["selectList1", "selectList2", "selectList3"]) {
            if (this.hasCustomOrder && key === this.userKey) {
              const serverSet = new Set(listMap[key]);
              const kept = this[key].filter(c => serverSet.has(c));
              const existing = new Set(kept);
              const added = listMap[key].filter(c => !existing.has(c));
              this[key] = [...kept, ...sortCards(added)];
            } else {
              this[key] = sortCards(listMap[key]);
            }
          }
          this.all = d.all || [];
          this.list5Up = d.we || [];
          this.click3 = d.click_3 || [];
          this.click4 = d.click_4 || [];
          this.click5 = d.click_5 || [];
          var newRoundTs = d.roundStartTs || 0;
          if (newRoundTs !== this.roundStartTs) {
            this.roundStartTs = newRoundTs;
            this.roundStartLocal = Date.now();
          }
          if (this.all.length >= 39) {
            const allCards = Array.from({ length: 52 }, (_, i) => i + 1);
            const s = new Set(this.all);
            this.list5 = sortCards(allCards.filter(x => !s.has(x)));
          }
          const myId = this.userInfo && this.userInfo.id;
          const notifs = d.notify || [];
          const pLabel = { 3: 'P1', 4: 'P2', 5: 'P3' };
          for (let n = 0; n < notifs.length; n++) {
            if (notifs[n].to === myId && notifs[n].ts > this.lastNotifyTs) {
              const names = (notifs[n].cards || []).map(c => cardIdToName(c)).join('、');
              const from = pLabel[notifs[n].from] || ('玩家' + notifs[n].from);
              this.$notify.warning({ title: '牌被拿走', message: from + ' 强制拿走了你的: ' + names + '，请检查手牌', duration: 8000 });
              this.lastNotifyTs = notifs[n].ts;
            }
          }
        }
      }).finally(() => { this.fetching = false; });
    },

    isAllowed() {
      return ["selectList1", "selectList2", "selectList3"].includes(this.userKey);
    },

    toFlip(item) {
      if (!this.isAllowed()) return;
      const myList = this[this.userKey];
      const isMine = myList.includes(item);
      if (isMine) {
        this.actionTs = Date.now();
        this[this.userKey] = myList.filter(x => x !== item);
        this.all = this.all.filter(x => x !== item);
        this.hasCustomOrder = false;
        this.$api.getUser.subCard({ card: item });
      } else {
        if (this.all.includes(item)) return;
        if (myList.length >= 13) return;
        this.actionTs = Date.now();
        this[this.userKey] = sortCards([...myList, item]);
        this.all = [...this.all, item];
        this.hasCustomOrder = false;
        this.$api.getUser.addCard({ card: item });
      }
    },

    toTop(item) {
      if (!this.isAllowed()) return;
      this.actionTs = Date.now();
      const has = this.list5Up.includes(item);
      if (has) {
        this.list5Up = this.list5Up.filter(x => x !== item);
        this.$api.getUser.downCard({ card: item });
      } else {
        this.list5Up = [...this.list5Up, item];
        this.$api.getUser.upCard({ card: item });
      }
    },

    onDragStart(e, idx, listKey) {
      if (this.userKey !== listKey) { e.preventDefault(); return; }
      this.dragFromIdx = idx;
      this.dragListKey = listKey;
      this.dragItem = this[listKey][idx];
      e.dataTransfer.effectAllowed = "move";
    },
    onDrop(e, toIdx, listKey) {
      if (this.dragListKey !== listKey || this.dragFromIdx === toIdx) return;
      const arr = [...this[listKey]];
      const [moved] = arr.splice(this.dragFromIdx, 1);
      arr.splice(toIdx, 0, moved);
      this[listKey] = arr;
      this.dragItem = null;
      this.hasCustomOrder = true;
    },
    onDragEnd() {
      this.dragItem = null;
      this.dragFromIdx = -1;
      this.dragListKey = "";
    },

    clearPlayingCardOne() {
      if (!this.isAllowed()) return;
      this.actionTs = Date.now();
      const myList = [...this[this.userKey]];
      this[this.userKey] = [];
      this.hasCustomOrder = false;
      this.recogOrder = [];
      this.$set(this.optMode, this.userKey, '');
      const s = new Set(myList);
      this.all = this.all.filter(x => !s.has(x));
      this.$api.getUser.rest();
    },

    confirmResetAll() {
      if (!this.isAllowed()) return;
      this.$confirm("确定要重置全部玩家的牌吗？此操作不可撤销。", "确认重置", {
        confirmButtonText: "确定重置",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.clearPlayingCard();
      }).catch(() => {});
    },

    returnCard(item, listKey) {
      if (this.userKey !== listKey || !this.isAllowed()) return;
      const myList = this[this.userKey];
      if (!myList.includes(item)) return;
      this.actionTs = Date.now();
      this[this.userKey] = myList.filter(x => x !== item);
      this.all = this.all.filter(x => x !== item);
      this.$api.getUser.subCard({ card: item });
    },

    onRecogFile: function(e) {
      var file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (file) this.submitRecog(file);
    },

    triggerFilePick: function() {
      this.$refs.recogInput.click();
    },

    onRecogDragOver: function(e) {
      if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.indexOf('Files') !== -1) {
        this.recogDragHover = true;
      }
    },
    onRecogDragLeave: function() { this.recogDragHover = false; },
    onRecogDrop: function(e) {
      this.recogDragHover = false;
      if (!this.isAllowed()) return;
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (file && file.type && file.type.indexOf('image/') === 0) this.submitRecog(file);
    },

    submitRecog: function(file) {
      if (!this.isAllowed() || this.recognizing) return;
      this.recognizing = true;
      var self = this;
      self.actionTs = Date.now() + 8000;
      var reader = new FileReader();
      reader.onload = function(ev) { self.recogImageUrl = ev.target.result; };
      reader.readAsDataURL(file);
      var formData = new FormData();
      formData.append('file', file);
      var roundAge = self.roundStartLocal > 0 ? Date.now() - self.roundStartLocal : Infinity;
      var needFullReset = self.all.length >= 39 && roundAge > 30000;
      fetch('/api/recognize', { method: 'POST', body: formData })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (!data.success || !data.cards || data.cards.length === 0) {
            self.$message.error(data.error || '未识别到扑克牌，请重试');
            return;
          }
          var recognized = [];
          for (var i = 0; i < data.cards.length; i++) {
            var cardId = classIdToCardId(data.cards[i].class_id);
            if (recognized.indexOf(cardId) === -1 && recognized.length < 13) {
              recognized.push(cardId);
            }
          }
          var clearPromise;
          if (needFullReset) {
            self.selectList1 = [];
            self.selectList2 = [];
            self.selectList3 = [];
            self.all = [];
            self.list5Up = [];
            self.click3 = [];
            self.click4 = [];
            self.click5 = [];
            self.list5 = [];
            self.optMode = { selectList1: '', selectList2: '', selectList3: '', p4: '' };
            clearPromise = self.$api.getUser.restAll().then(function(res) {
              if (res && res.data && res.data.roundStartTs) {
                self.roundStartTs = res.data.roundStartTs;
                self.roundStartLocal = Date.now();
              }
              return res;
            });
          } else {
            clearPromise = self.$api.getUser.rest();
          }
          var otherAll = needFullReset ? [] : self.all.filter(function(c) { return !self[self.userKey].includes(c); });
          if (!needFullReset) {
            self[self.userKey] = [];
            self.all = otherAll.slice();
          }
          var otherSet = new Set(otherAll);
          var added = [];
          var duplicates = [];
          var dupIds = [];
          var pNames = { selectList1: 'P1', selectList2: 'P2', selectList3: 'P3' };
          for (var k = 0; k < recognized.length; k++) {
            if (otherSet.has(recognized[k])) {
              var owner = '';
              for (var pk in pNames) {
                if (pk !== self.userKey && self[pk].includes(recognized[k])) { owner = pNames[pk]; break; }
              }
              if (owner) {
                duplicates.push({ id: recognized[k], name: cardIdToName(recognized[k]), owner: owner, ownerKey: pk });
                dupIds.push(recognized[k]);
              }
            } else {
              added.push(recognized[k]);
            }
          }
          self.recogOrder = recognized.slice();
          self.hasCustomOrder = true;
          self[self.userKey] = sortCards(added);
          for (var a = 0; a < added.length; a++) { self.all.push(added[a]); }
          var serverPromise = clearPromise.then(function() {
            if (added.length > 0) return self.$api.getUser.batchAddCards({ cards: added });
          }).catch(function() {
            if (added.length > 0) return self.$api.getUser.batchAddCards({ cards: added });
          }).finally(function() {
            self.actionTs = Date.now();
          });
          if (added.length > 0) {
            self.$message.success('已识别并选中 ' + added.length + ' 张牌' + (duplicates.length > 0 ? '，' + duplicates.length + ' 张有冲突' : ''));
          }
          if (duplicates.length > 0) {
            var grouped = {};
            for (var d = 0; d < duplicates.length; d++) {
              var o = duplicates[d].owner;
              if (!grouped[o]) grouped[o] = [];
              grouped[o].push(duplicates[d].name);
            }
            var lines = [];
            for (var g in grouped) { lines.push('与' + g + '重复: ' + grouped[g].join('、')); }
            var msg = lines.join('\n') + '\n\n选择"强制选牌"将从对方手中拿走这些牌';
            self.$confirm(msg, '识别牌有重复', {
              confirmButtonText: '强制选牌',
              cancelButtonText: '我手动处理',
              type: 'warning'
            }).then(function() {
              self.actionTs = Date.now() + 5000;
              serverPromise.then(function() {
                return self.$api.getUser.forceClaimCards({ cards: dupIds });
              }).then(function() {
                for (var i = 0; i < dupIds.length; i++) {
                  if (!self[self.userKey].includes(dupIds[i])) {
                    self[self.userKey].push(dupIds[i]);
                  }
                  for (var pk2 in pNames) {
                    if (pk2 !== self.userKey) {
                      self[pk2] = self[pk2].filter(function(c) { return dupIds.indexOf(c) === -1; });
                    }
                  }
                  if (self.all.indexOf(dupIds[i]) === -1) self.all.push(dupIds[i]);
                }
                self[self.userKey] = sortCards(self[self.userKey]);
                self.recogOrder = recognized.slice();
                self.$message.success('已强制选取 ' + dupIds.length + ' 张重复牌');
                self.actionTs = Date.now();
              }).catch(function() {
                self.$message.error('强制选牌失败，请手动处理');
                self.actionTs = Date.now();
              });
            }).catch(function() {});
          } else if (added.length === 0) {
            self.$message.warning('识别到的牌均已被其他玩家选走');
          }
        })
        .catch(function(err) {
          self.$message.error('识别服务不可用：' + (err.message || '请检查网络'));
        })
        .finally(function() { self.recognizing = false; });
    },

    toggleOpt(key) {
      var newMode = this.optMode[key] === 'opt' ? '' : 'opt';
      this.$set(this.optMode, key, newMode);
      this.$set(this.optRank, key, 0);
      if (newMode === '' && key === this.userKey && this.hasCustomOrder) {
        this[key] = sortCards(this[key]);
        this.hasCustomOrder = false;
      }
    },
    setRecogMode(key) {
      this.$set(this.optMode, key, this.optMode[key] === 'recog' ? '' : 'recog');
    },
    setOptRank(key, idx) {
      this.$set(this.optRank, key, idx);
    },

    clearPlayingCard() {
      if (!this.isAllowed()) return;
      this.actionTs = Date.now() + 3000;
      this.selectList1 = [];
      this.selectList2 = [];
      this.selectList3 = [];
      this.all = [];
      this.list5Up = [];
      this.click3 = [];
      this.click4 = [];
      this.click5 = [];
      this.list5 = [];
      this.hasCustomOrder = false;
      this.recogOrder = [];
      this.optMode = { selectList1: '', selectList2: '', selectList3: '', p4: '' };
      return this.$api.getUser.restAll();
    },

    pickWatchFolder: async function() {
      if (typeof window.showDirectoryPicker !== 'function') {
        this.$alert(
          '当前环境不支持文件夹监控。<br/><br/>需要满足以下条件：<br/>1. 使用 <b>Chrome</b> 或 <b>Edge</b> 浏览器<br/>2. 通过 <b>HTTPS</b> 或 <b>localhost</b> 访问<br/><br/>当前是 HTTP 访问，请联系管理员开启 HTTPS',
          '浏览器不支持',
          { dangerouslyUseHTMLString: true, type: 'warning' }
        );
        return;
      }
      try {
        var handle = await window.showDirectoryPicker({ mode: 'read' });
        this.watchDirHandle = handle;
        this.watchDirName = handle.name;
        this.watchKnownFiles = new Set();
        for await (var entry of handle.values()) {
          if (entry.kind === 'file') {
            var n = entry.name.toLowerCase();
            if (n.endsWith('.png') || n.endsWith('.jpg') || n.endsWith('.jpeg') || n.endsWith('.bmp')) {
              this.watchKnownFiles.add(entry.name);
            }
          }
        }
        this.$message.success('已选择文件夹: ' + handle.name + ' (已有 ' + this.watchKnownFiles.size + ' 张图片)');
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.$message.error('选择文件夹失败: ' + (e.message || ''));
        }
      }
    },

    toggleWatch: function() {
      if (!this.watchDirHandle) {
        this.$message.warning('请先点击"选目录"选择文件夹');
        return;
      }
      if (this.watchActive) {
        clearInterval(this.watchTimer);
        this.watchTimer = null;
        this.watchActive = false;
        this.$message.info('已停止自动抓图');
      } else {
        this.watchActive = true;
        var self = this;
        this.watchTimer = setInterval(function() { self.scanForNewImages(); }, 2000);
        this.$message.success('自动抓图已开启，每2秒扫描文件夹');
      }
    },

    scanForNewImages: async function() {
      if (!this.watchDirHandle || !this.watchActive || this.recognizing) return;
      try {
        await this.watchDirHandle.requestPermission({ mode: 'read' });
      } catch (e) {
        this.watchActive = false;
        clearInterval(this.watchTimer);
        this.watchTimer = null;
        this.$message.error('文件夹访问权限已失效，请重新选择文件夹');
        return;
      }
      try {
        var newFiles = [];
        for await (var entry of this.watchDirHandle.values()) {
          if (entry.kind === 'file') {
            var n = entry.name.toLowerCase();
            if ((n.endsWith('.png') || n.endsWith('.jpg') || n.endsWith('.jpeg') || n.endsWith('.bmp'))
                && !this.watchKnownFiles.has(entry.name)) {
              newFiles.push(entry);
            }
          }
        }
        if (newFiles.length === 0) return;
        newFiles.sort(function(a, b) { return a.name > b.name ? 1 : -1; });
        var latest = newFiles[newFiles.length - 1];
        for (var i = 0; i < newFiles.length; i++) {
          this.watchKnownFiles.add(newFiles[i].name);
        }
        var file = await latest.getFile();
        this.submitRecog(file);
      } catch (e) {
        // noop - transient read error
      }
    },
  },
  beforeDestroy: function() {
    if (this.watchTimer) { clearInterval(this.watchTimer); this.watchTimer = null; }
  },
};
</script>

<style lang="less" scoped>
.board {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  user-select: none;
  display: flex;
  flex-direction: column;
  background: #e8ecf1;

  --cw: min(calc((100vw - 40px) / 13), calc((100vh - 60px) / 12));
  --ch: calc(var(--cw) * 1.5);
  --g: 2px;

  --avail: calc(100vh - 4 * var(--ch) - 16px);
}

/* === 牌池小牌 === */
.cs {
  width: var(--cw);
  height: var(--ch);
  border-radius: 4px;
  border: 2px solid transparent;
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;
  background: #fff;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    pointer-events: none;
  }
}
.cs.taken { opacity: 0.6; cursor: default; }

/* (P4 placeholder styles removed - P4 now uses same .hc cards) */

/* === 玩家手牌（三墩） === */
.hc {
  width: var(--hcw);
  height: var(--hch);
  border-radius: 4px;
  border: 2px solid transparent;
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;
  background: #fff;
  transition: transform 0.12s, box-shadow 0.12s;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    pointer-events: none;
  }

  &:hover { transform: translateY(-2px); box-shadow: 0 3px 8px rgba(0,0,0,0.15); }
}
.hc.dragging { opacity: 0.4; }

.p4-badge {
  background: linear-gradient(135deg, #409eff, #2070c0);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 10px;
  white-space: nowrap;
  letter-spacing: 1px;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.45);
}
.special-badge {
  background: linear-gradient(135deg, #ff6b35, #f7c948);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 10px;
  white-space: nowrap;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.5);
  animation: specialPulse 1.5s ease-in-out infinite;
}
@keyframes specialPulse {
  0%, 100% { box-shadow: 0 2px 8px rgba(255, 107, 53, 0.5); }
  50% { box-shadow: 0 2px 16px rgba(255, 107, 53, 0.9); }
}
.hand-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-hint {
  color: #8aa5c0;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1.6;
}

.pc-p4 {
  border: 3px solid #409eff !important;
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.5), inset 0 0 4px rgba(64, 158, 255, 0.15);
  background: #f0f7ff;
}
.b-yellow { border-color: #e6b800 !important; }
.b-red    { border-color: #e74c3c !important; }
.b-green  { border-color: #27ae60 !important; }

/* === 牌池 Grid === */
.pond {
  display: grid;
  grid-template-columns: repeat(13, var(--cw));
  grid-template-rows: repeat(4, var(--ch));
  gap: var(--g);
  justify-content: center;
  padding: 4px;
  background: #fff;
  border-bottom: 2px solid #cfd4db;
}

/* === 下半区 === */
.players {
  flex: 1;
  gap: 3px;
  min-height: 0;
  overflow: hidden;
  padding: 2px;
}
.layout-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  --player-h: calc(var(--avail) / 2);
  --hch: calc((var(--player-h) - 24px) / 2);
  --hcw: calc(var(--hch) / 1.4);
  --row-overlap: calc(var(--hch) * -0.5);
}
.layout-grid-img {
  display: grid;
  grid-template-areas:
    "recog p4    other1"
    "recog self  other2";
  grid-template-columns: 1.4fr 1fr 0.7fr;
  grid-template-rows: 1fr 1fr;
  --player-h: calc(var(--avail) / 2);
  --hch: calc((var(--player-h) - 20px) / 2.2);
  --hcw: calc(var(--hch) / 1.4);
  --row-overlap: calc(var(--hch) * -0.4);
  .recog-cell { grid-area: recog; }
  .remaining-bg { grid-area: p4; }
  .quad-head { padding: 2px 4px; flex-wrap: wrap; gap: 2px; }
  .btn-opt, .btn, .btn-reset-all { font-size: 10px; padding: 2px 6px; }
  .tag { font-size: 10px; padding: 1px 5px; }
  .rank-btn { padding: 1px 4px; font-size: 9px; }
  .rank-no { width: 12px; height: 12px; font-size: 8px; }
}
/* === 每个象限 === */
.quad {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  min-height: 0;
}
.remaining-bg {
  background: linear-gradient(135deg, #e8f2fc, #d6e8f8);
  border: 2px solid #a3c6e8;
}
.bg-p1 { background: #fffde6; border: 2px solid #e6b800; }
.bg-p2 { background: #fff0f0; border: 2px solid #e74c3c; }
.bg-p3 { background: #eefbf3; border: 2px solid #27ae60; }

/* 象限顶栏：标签 + 按钮 */
.quad-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 2px;
}

/* === 三墩手牌区 === */
.hand-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: visible;
  padding: 0;
}

.hand-row {
  display: flex;
  justify-content: center;
  position: relative;

  .hc + .hc { margin-left: calc(var(--hcw) * -0.3); }
}
.hand-row + .hand-row {
  margin-top: var(--row-overlap);
}
.hand-back {
  .hc + .hc { margin-left: calc(var(--hcw) * -0.15); }
}

.head-btns {
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn-opt {
  padding: 4px 12px;
  border: 2px solid transparent;
  border-radius: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: all 0.25s;
  letter-spacing: 1px;
  &:hover { transform: scale(1.05); }
}
.opt-inactive {
  background: #eceff1;
  color: #546e7a;
  border-color: #b0bec5;
}
.opt-active {
  background: linear-gradient(135deg, #ff9800, #f44336);
  color: #fff;
  border-color: #e65100;
  box-shadow: 0 2px 10px rgba(244, 67, 54, 0.45);
  animation: optPulse 1.5s ease-in-out infinite;
}
.opt-recog-active {
  background: linear-gradient(135deg, #2196f3, #00bcd4);
  color: #fff;
  border-color: #0d47a1;
  box-shadow: 0 2px 10px rgba(33, 150, 243, 0.45);
}
@keyframes optPulse {
  0%, 100% { box-shadow: 0 2px 10px rgba(244, 67, 54, 0.45); }
  50% { box-shadow: 0 2px 16px rgba(244, 67, 54, 0.7); }
}
.rank-bar {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
  margin-top: 2px;
}
.rank-btn {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border: 1.5px solid #cfd8dc;
  border-radius: 10px;
  background: #f5f5f5;
  color: #78909c;
  cursor: pointer;
  font-size: 10px;
  font-weight: 600;
  transition: all 0.2s;
  &:hover { background: #e3f2fd; border-color: #64b5f6; }
}
.rank-active {
  background: linear-gradient(135deg, #1976d2, #1565c0);
  color: #fff;
  border-color: #0d47a1;
  box-shadow: 0 1px 6px rgba(25, 118, 210, 0.4);
}
.rank-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(0,0,0,0.1);
  font-size: 9px;
  font-weight: 800;
}
.rank-active .rank-no { background: rgba(255,255,255,0.25); }
.rank-pct { font-size: 10px; }

.tag {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 10px;
  white-space: nowrap;
}
.tg-1 { background: #fef3cd; color: #856404; }
.tg-2 { background: #f8d7da; color: #842029; }
.tg-3 { background: #d1e7dd; color: #0f5132; }

.btn {
  padding: 4px 12px;
  background: linear-gradient(135deg, #409eff, #3083d9);
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.35);
  transition: all 0.2s;

  &:hover { background: linear-gradient(135deg, #5aafff, #409eff); transform: scale(1.05); }
  &:active { background: linear-gradient(135deg, #3083d9, #2070c0); transform: scale(0.97); }
}

.btn-reset-all {
  padding: 4px 10px;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(231, 76, 60, 0.4);
  transition: all 0.2s;

  &:hover {
    background: linear-gradient(135deg, #ff5e4f, #e74c3c);
    box-shadow: 0 3px 10px rgba(231, 76, 60, 0.55);
    transform: scale(1.05);
  }
  &:active {
    background: linear-gradient(135deg, #c0392b, #a93226);
    transform: scale(0.97);
  }
}

/* ===== 图片识别区域 ===== */
.recog-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f4f8, #e8ecf1);
  border: 2px dashed #b0bec5;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.2s;
  &:hover { background: linear-gradient(135deg, #e4eaf0, #dde3ea); border-color: #90a4ae; }
}
.recog-drag-hover {
  border-color: #f39c12 !important;
  border-style: dashed !important;
  background: rgba(243, 156, 18, 0.08) !important;
}
.recog-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 4px;
}
.recog-placeholder {
  color: #90a4ae;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1.8;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.recog-status {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0,0,0,0.65);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 16px;
}
.recog-spinner-sm {
  width: 16px; height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #f39c12;
  border-radius: 50%;
  animation: recogSpin 0.7s linear infinite;
  display: inline-block;
  flex-shrink: 0;
}
.recog-loading-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #f39c12;
  font-weight: 700;
}
@keyframes recogSpin { to { transform: rotate(360deg); } }

/* ===== 自动抓图 - 右上角悬浮 ===== */
.watch-overlay {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 10;
}
.watch-btn {
  padding: 3px 8px;
  border: 1.5px solid rgba(255,255,255,0.6);
  border-radius: 10px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  transition: all 0.2s;
  background: rgba(0,0,0,0.45);
  color: #fff;
  backdrop-filter: blur(4px);
  &:hover:not(:disabled) { transform: scale(1.05); background: rgba(0,0,0,0.6); }
  &:disabled { opacity: 0.35; cursor: not-allowed; }
}
.watch-btn-folder {
  background: rgba(0,0,0,0.4);
  border-color: rgba(255,255,255,0.5);
}
.watch-btn-start {
  background: rgba(46,125,50,0.85);
  border-color: rgba(255,255,255,0.5);
  &:hover:not(:disabled) { background: rgba(46,125,50,0.95); }
}
.watch-btn-stop {
  background: rgba(198,40,40,0.85);
  border-color: rgba(255,255,255,0.5);
  animation: watchPulse 1.5s ease-in-out infinite;
  &:hover { background: rgba(198,40,40,0.95); }
}
@keyframes watchPulse {
  0%, 100% { box-shadow: 0 0 0 rgba(198,40,40,0); }
  50% { box-shadow: 0 0 8px rgba(198,40,40,0.5); }
}
.watch-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4caf50;
  display: inline-block;
  flex-shrink: 0;
  box-shadow: 0 0 4px rgba(76,175,80,0.6);
  animation: watchDotBlink 1s ease-in-out infinite;
}
@keyframes watchDotBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
</style>
